<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputChannels" });
import Icon from "../../../../elements/icon/Icon.svelte";
import { t } from "svelte-i18n";
export let codes = [];
</script>

{#each codes as code}

    {#if typeof code === 'string'}

        <span class = 's8-channel mr-2'>
            <Icon key = { code } css = 'h-3.5 w-4 -mt-1 !inline-block'/>
            { $t(`resource.channel.options.${ code }.label`) }
        </span>

    {/if}

{/each}